// eslint-disable-next-line import/prefer-default-export
export function hasApplicationRole() {
  return window.sessionHandler.userRoles.some(role => role === 'application_support')
}
